exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".my-tag[data-v-126358f8]{font-size:14px;border:1px solid gray;border-radius:2px;padding:0 2px}.my-tag>.fa-times-circle[data-v-126358f8]{cursor:pointer}.my-tag>.fa-times-circle[data-v-126358f8]:hover{color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-126358f8","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Dropdown/myTag.vue
// module id = 167
// module chunks = 0